import React, { useState } from 'react';
import "../css/ThemeToggler.scss";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const ThemeToggler = () => {
    const notify = () => toast('This feature will be available soon !❤️', {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        theme: "dark",
        });
    return (
       <> <ToastContainer
        position="top-center"
        autoClose={2000}
        hideProgressBar
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
        <div className='themeToggler'>
            <div className="themerButtons">
                <button onClick={notify} ></button>
                <button onClick={notify}></button>
                <button onClick={notify}></button>
                <button onClick={notify}></button>
            </div>
        </div>
    </>
    )
}

export default ThemeToggler